import React, { Component } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
//import TableComp from '../../../../components/_utils/table'
import { TableComp } from 'sz-react-utils'
import moment from 'moment'
import _ from 'lodash'
import ListFollowUps from '../../../../components/_utils/listFollowUp'
import {
    Row,
    Avatar,
    Button,
    Card,
    Select,
    Tooltip,
    Checkbox,
    notification,
    Col,
    DatePicker,
    Popconfirm,
    Input
} from 'antd'
import Request from '../../../../request'

import { connect } from 'react-redux'
import styles from './styles.less'
import { getUrlPushWrapper } from '../../../../routes'
import common from '../../../common.less'
import LatestFollowUp from '../../../../components/_utils/latestFollowup'
import Settings from '../../../../components/_utils/settings'
import rightAuth from "../../../../components/_utils/userRights";

import lodash from 'lodash'

import SMS from '../../../../components/communication/sms'
import WhatsAPPSMS from '../../../../components/communication/WhatsAppSms'
import EmailDrawer from '../../../../components/communication/emailDrawer'
import { RightsWrapper } from '../../../../components/_utils/utils'
const showDroppedLeads = rightAuth.checkUserRights('showDropLead')
const showDropLead = rightAuth.checkUserRights('dropLead')
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
let studentObj = {};
let userCheckBox = {}
let counsellingData = {}
const Option = Select.Option
const { RangePicker } = DatePicker
const { Search } = Input
class CollapseViewBox extends Component {
    state = {
        cp: false
    }

    render() {
        const { cp } = this.state
        const clondData = this.props.children
        return <React.Fragment>
            <div>
                <div className={cp ? styles.questioncollapse : styles.questioncollapsenot}>
                    {clondData && clondData.course.slice(0, cp ? (clondData.course.length) : 1).map((item) => {
                        return <ul className={styles.ul}>
                            <li><b>{item.courseName}{item.campusName && `(${item.campusName})`}</b></li>
                            <li>{item.universityInstitutionName}</li>
                            <li>
                                <small>   {item.univData && item.univData.universityCityId && `${item.univData.universityCityId.cityName} ,`}
                                    {item.univData && item.univData.universityStateId && `${item.univData.universityStateId.stateName} ,`}
                                    {item.univData && item.univData.universityCountryId && `${item.univData.universityCountryId.countryName}`}</small>
                            </li>

                        </ul>

                    })}

                </div>
                {clondData && clondData.course && clondData.course.length > 1 ?
                    <a style={{ color: 'red' }} onClick={() => {
                        this.setState({
                            cp: !cp
                        })
                    }}>
                        {cp ? <p>View Less - </p> : <p>View More + </p>}
                    </a> : null}
            </div>
        </React.Fragment>
    }
}


class RegistrationDesk extends Component {
    state = {
        search_keyword: '',
        count: 0,
        followDuesCount: 0,
        showFollowUp: false,
        studentId: null,
        branchId: '',
        counsellorId: '',
        counsellors: [],
        allBranches: [],
        allCounsellor: [],
        modeArr: [],
        loading: true,
        deskColor: null,
        ratingArr: ['Fit2Apply', 'Potential', 'Luke Warm', 'Cold', 'Dead'],
        isFollowUpOverdue: false,
        showSMS: false,
        showWhatsAppSms: false,
        allcountries: [],
        showEmail: false,
        userCheckBox: {},
        studentSearchId: '',
        showDropped: false,
        exportParams: {},
    }
    showSMS = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showSMS: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeSMS = () => {
        this.setState({ showSMS: false })
    }
    showWhatsAppSms = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return (item.isChecked == true ? item : false);
        })

        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showWhatsAppSms: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    getAllSource = async () => {
        let response = await Request.getSourceDetails({
            results: 1000,
            count: 1000
        })
        let sourceObject = [];
        response.data && response.data.map((source) => {
            sourceObject.push(source.sourceName)

        })
        this.setState({ modeArr: sourceObject })
    }

    dropLeads = async () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            let response = await Request.dropInquiry(counsellingData)
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: 'Something Went Wrong'
                })
            }
            this.table.current.reload()
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }

    toggleDroppedLeads = () => {
        let showDropped = this.state.showDropped;
        showDropped = !showDropped
        this.setState({ showDropped }, () => {
            this.table.current.reload()
        })
    }
    closeWhatsSMS = () => {
        this.setState({ showWhatsAppSms: false })
    }
    closeEmail = () => {
        this.setState({ showEmail: false })
    }
    showEmail = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showEmail: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    selectUser = (item, studentId) => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        if (cloneUserCheckBox[studentId] == undefined) {
            cloneUserCheckBox[studentId] = [];
        }
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    selectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = true
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }

    async loadCountries() {
        let { data: countriesList } = await Request.getCountriesWithoutAuth({
            results: 10000,
            businessId: activeUser && activeUser.businessId
        })
        let countryList = []
        _.each(countriesList, (item) => {
            countryList.push({ value: item.countryName, text: item.countryName })
        })
        this.setState({ allcountries: countryList })
    }

    unselectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = false
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    apiRequest = (params, columns) => {


        return new Promise(async resolve => {
            // params.count = 200

            if (!params.sortField) {
                params.sortField = 'moveDeskDate.moveToRegistrationDesk'
                params.sortOrder = 'descend'
            }

            params.dropped = this.state.showDropped

            // if (!params.rating) {
            //   params.rating = ['High', 'Medium']
            // }
            if (this.state.search_keyword && this.state.search_keyword !== "") {
                params.keyword = this.state.search_keyword
            }
            if (this.state.counsellorId) {
                params.counsellorId = this.state.counsellorId
                params.page = 1
            }
            if (this.state.studentSearchId) {
                params.studentSearchId = this.state.studentSearchId
                params.page = 1
            } else {
                params.studentSearchId = '';
            }
            if (this.state.branchId) {
                params.studentBranchId = this.state.branchId
                params.page = 1
            }

            params.atLevel = ['Registration Desk']

            if (this.state.isFollowUpOverdue) {
                params.isFollowUpOverdue = this.state.isFollowUpOverdue;
            }

            if (params.dateOfBirth && params.dateOfBirth.length > 0) {
                var splitDate = params.dateOfBirth[0].split('-');
                const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
                var monthName = monthNames[splitDate[1] - 1];

                params.dateOfBirth = splitDate[0] + '-' + monthName + '-' + splitDate[2];

                const stringToDate = new Date(params.dateOfBirth);
                params.dateOfBirth = {
                    $gte: moment(params.dateOfBirth, dateFormat).startOf('day'),
                    $lt: moment(params.dateOfBirth, dateFormat).endOf('day'),
                };
            } else {
                delete params.dateOfBirth
            }
            let data = await Request.loadCounselling({
                ...params,
                regExFilters: ['studentName', 'mobile', 'email', 'updatedByUser.name', 'createdByUser.name'],
                dateFilter: this.state.time

            })

            delete data.error
            delete data.type
            lodash.each(data.data, (item) => {
                if (!userCheckBox[item._id]) {
                    userCheckBox[item._id] = {
                        _id: item._id,
                        emailId: item.emailId,
                        mobile: item.mobile,
                        studentName: item.studentName,
                        isChecked: false
                    }
                }
            })

            this.setState({ count: data.total, followDuesCount: data.followUpsDuesCount, allBranches: data.allBranches, userCheckBox: userCheckBox, exportParams: params })
            resolve(data)
        })
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.followUpsCallback = this.followUpsCallback.bind(this);

        Request.getCounsellorsUsers()
            .then(resp => {
                if (resp) {
                    let temp = [{ display: '---Show All---', id: '' }];
                    resp.data = resp.data.reduce((el, vv) => {
                        vv.display = vv.name
                        vv.id = vv._id
                        temp.push(vv)
                        return temp
                    }, []);
                    this.setState({ counsellors: resp.data })
                }
            })
            .catch(err => {
            })
    }

    closeFollowUp = () => {
        this.setState({ showFollowUp: false })
        this.table.current.reload()
    }
    openFollowUps = record => {
        studentObj = {
            arr: record.followUp,
            name: record.studentName,
            rating: record.counsellingDesk.rating,
            subRating: record.counsellingDesk.subRating,
            _id: record._id
        }
        this.setState({ showFollowUp: true })
    }

    changeSearchValue = (value) => {
        this.setState({ search_keyword: value }, () => {
            this.table.current.reload()
        })
    }
    renderStatus = (val) => {

        if (val === 'Super Hot') {
            return <div className={styles.SuperHot}>{val.toUpperCase()}</div>
        }
        if (val === 'Fit2Apply') {
            return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>
        }

        if (val === 'Luke Warm') {
            return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>
        }

        if (val === 'Potential') {
            return <div className={styles.Warm}>{val.toUpperCase()}</div>
        }

        if (val === 'Dead') {
            return <div className={styles.dead}>{val.toUpperCase()}</div>
        }

        if (val === 'Cold') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
    }

    followUpExtendedDate = (followUp) => {
        if (followUp && followUp.followUpDate) {
            return moment(moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]')).isAfter(followUp.followUpDate);
        }
    }
    chooseRangerPicker = (date, dateString) => {
        this.setState(
            {
                time: {
                    key: "moveDeskDate.moveToRegistrationDesk",
                    from: moment(date[0]).startOf('day'),
                    to: moment(date[1]).endOf('day'),
                },
            },
            () => {
                this.table.current.reload();
            }
        );
        if (date[0] == undefined) {
            setTimeout(() => {
                this.table.current.reload();
            }, 500);
        }
    };

    onOk = value => {
        this.table.current.reload();
    }
    componentWillMount() {
        let searchParams = new URLSearchParams(this.props.search)
        let createdByUserDate = searchParams.get('dateFilter')
        let dateFilterByWeekOrMonth = searchParams.get('dateFilterByWeekOrMonth')
        let registrationDate = searchParams.get('registrationDate')
        if (dateFilterByWeekOrMonth) {
            let weakStartDate = moment().startOf(`${dateFilterByWeekOrMonth}`).format()
            let weakEndDate = moment().endOf(`${dateFilterByWeekOrMonth}`).format()
            this.setState({
                time: {
                    key: 'registrationDesk.registrationDate',
                    from: weakStartDate,
                    to: weakEndDate
                },

            }, () => {
                console.log('adsffs', this.state.time)
            })
        }

        if (createdByUserDate) {
            this.setState({
                time: {
                    key: 'moveDeskDate.moveToRegistrationDesk',
                    from: moment(createdByUserDate, 'DD-MM-YYYY').startOf('day').toDate(),
                    to: moment(createdByUserDate, 'DD-MM-YYYY').endOf('day').toDate(),
                }
            }, () => {
                console.log('adsffs', this.state.time)
            })


        }

        if (registrationDate) {
            this.setState({
                time: {
                    key: 'registrationDesk.registrationDate',
                    from: moment(registrationDate, 'DD-MM-YYYY').startOf('day').toDate(),
                    to: moment(registrationDate, 'DD-MM-YYYY').endOf('day').toDate(),
                }
            }, () => {
                console.log('adsffs', this.state.time)
            })

        }

        this.setState({ deskColor: Settings.deskColor('Registration Desk') })
    }

    async componentDidMount() {
        window.onkeydown = function (e) {
            var ck = e.keyCode ? e.keyCode : e.which;
            if (e.ctrlKey && ck == 70) {
                if (document.querySelector('#search-student-input')) {
                    document.querySelector('#search-student-input').focus();
                }
                return false;
            } else if (ck == 27) {
                if (document.querySelector('#search-student-input')) {
                    document.querySelector('#search-student-input').focus();
                }
                return false;
            }
        }
        await this.loadCountries()
        await this.getAllSource()
        let { data } = await Request.loadCounsellor({
            results: 10000,
            atLevel: ['Registration Desk']
        })
        this.setState({
            allCounsellor: data, loading: false
        })

    }


    exportExcel = async () => {
        const { exportParams, count } = this.state
        exportParams.results = count
        exportParams.count = count
        // let x = await Request.exportOperationDeskToExcel({...exportParams});
        let x = await Request.exportCounsellingDeskToExcel({ ...exportParams });
        // let x = await Request.exportUsersToExcel({
        //      regExFilters: ['name'
        //     ]
        // })
        if (!x.error) {
            window.open(x.url)
        }
    }

    followUpsCallback(isFollowUpOverdue) {
        this.setState({
            isFollowUpOverdue: isFollowUpOverdue,
        }, () => {
            this.table.current.reload()
        });
    }

    render() {
        const { dispatch } = this.props
        const { allBranches = [], allCounsellor = [], deskColor, counsellors, allcountries, modeArr } = this.state

        const columns = [
            {
                title: 'Action',
                key: 'operation',
                dataindex: 'operation',
                fixed: true,
                width: 70,
                render: (text, record) => (
                    <React.Fragment>
                        <div className={styles.wrap}>
                            <span className={styles.userSelectCheckbox}>
                                <Checkbox
                                    checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
                                    onChange={y => {
                                        this.selectUser(y, record._id)
                                    }}>
                                </Checkbox>
                            </span>
                            <Tooltip title="Notes">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    size={'small'}
                                    onClick={() => this.openFollowUps(record)}
                                    icon="calendar"
                                />
                            </Tooltip>
                            <Tooltip title="Click To Edit Details">
                                <Button
                                    className={styles.btn}
                                    size={'small'}
                                    shape="circle"
                                    href={`/registration/fees?id=${record._id}`}
                                    icon="edit"
                                />
                            </Tooltip>
                        </div>
                    </React.Fragment>
                )
            },
            {
                title: 'VID',
                key: 'id',
                dataIndex: 'id',
                sorter: true,
                fixed: true,
                width: 120,
                searchTextName: 'id',
                filterRegex: true
            },
            {
                title: 'Student Name',
                key: 'studentName',
                dataIndex: 'studentName',
                sorter: true,
                fixed: true,
                width: 200,
                searchTextName: 'studentName',
                filterRegex: true,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            <div
                                className={
                                    this.followUpExtendedDate(record.followUp ? record.followUp : '') ? styles.followUpExtendedDate : ''
                                }
                            >
                                <Tooltip title="Click To Edit Details">
                                    <a className={styles.btn} target={'_blank'}
                                        href={`/inquiry/studentProfileDetails?id=${record._id}`}
                                    >{text}</a>
                                </Tooltip>
                            </div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: "Date Of Birth ",
                width: 100,
                key: "dateOfBirth",
                dataIndex: "dateOfBirth",
                searchTextName: `${dateFormat}`,
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format(dateFormat)
                                : ""}
                        </div>
                    );
                },
            },
            {
                title: 'Passport No',
                key: 'passportNo',
                searchTextName: 'passportNo',
                filterRegex: true,
                width: 150,
                dataIndex: 'visaDesk.passportNo'
            },
            {
                title: "Preference",
                key: "preference",
                width: 120,
                filters: allcountries,
                render: (val, row) => {
                    return row.totalPreference ? (
                        <ul className={common.ul}>
                            {row.totalPreference.map((val, inde) => {
                                return <li key={inde}>{val ? val.country : ""}</li>;
                            })}
                        </ul>
                    ) : null;
                },
            },
            // {
            //     title: 'Photo',
            //     key: 'profilePic',
            //     width: 60,
            //     dataIndex: 'profilePic',
            //     render: val => {
            //         return (
            //             <Avatar src={val}/>
            //         )
            //     }
            // },
            {
                title: 'Consultancy Recieved',
                key: 'registrationDate',
                width: 120,
                dataIndex: 'registrationDate',
                render: (text, record) => {
                    return (
                        <div>
                            <div>Paid : {record && record.registrationDesk ? record.registrationDesk.paid : 0}</div>
                            <div>Balance
                                : {record && record.registrationDesk ? record.registrationDesk.balance : 0}</div>

                            <small>{record && record.registrationDesk ? moment(record.registrationDesk.registrationDate).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: "Source",
                key: "mode",
                width: 80,
                dataIndex: "mode",
                filters: modeArr && modeArr.map((x) => ({ value: x, text: x }))
            },
            {
                title: 'Agreement Signed',
                key: 'aggrementSigned',
                width: 80,
                render: (text, record) => (
                    record.applicationsDesk && record.applicationsDesk.aggrementSigned ? "Yes" : "No"
                )
            },
            {
                title: 'Counsellor',
                width: 180,
                key: 'counsellorId',
                filters: allCounsellor.map(x => ({ value: x._id, text: x.name })),
                render: (text, record) => {
                    return (
                        <div>{record.counsellorId ? record.counsellorId.name : ''}</div>
                    )
                }
            },
            {
                title: 'MOB/WAP/Mail',
                key: 'mobwap',
                dataIndex: 'mobwap',
                width: 180,
                searchTextName: 'MOB/WAP/Mail',
                render: (val, record) => {
                    return (
                        <div>
                            <div>
                                <span>{record.mobile}</span>
                            </div>
                            <div>

                                {record.watsupp && record.watsupp.length == 10 ?
                                    <Tooltip title="Share on Whatsapp">
                                        <a target={'_blank'}
                                            style={{ textDecoration: 'underline' }}
                                            href={`http://api.whatsapp.com/send?phone=91${record.watsupp}&text=&source=&data=`}>{record.watsupp}</a>
                                    </Tooltip>
                                    : record.watsupp}

                            </div>
                            <div>
                                <span>{record.emailId}</span>
                            </div>
                        </div>
                    )
                }
            },
            {
                title: 'Branch',
                width: 180,
                key: 'studentBranchId',
                filters: allBranches,
                render: (text, record) => {
                    return (
                        <div>
                            {record.studentBranchId ? record.studentBranchId.branchName : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Last FollowUp By',
                key: 'followUp.assignByName',
                searchTextName: 'Last FollowUp By',
                filterRegex: true,
                width: 160,
            },
            {
                title: 'Last Updated By',
                width: 150,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                searchTextName: 'createdByUser',
                filterRegex: true,
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            // {
            //     title: 'Source',
            //     key: 'source',
            //     width: 100,
            //     dataIndex: 'location'
            // },


            /*{
              title: 'Rating',
              key: 'rating',
              dataIndex: 'counsellingDesk.rating',
              // filters: ratingArr && ratingArr.map(x => ({value: x, text: x})),
              render: (val, record) => {
                return this.renderStatus(val)

              }


            },*/
            // {
            //     title: 'Follow Up',
            //     key: 'followUp',
            //     width: 200,
            //     dataIndex: 'followUp',
            //     render: (text, record) => {
            //         return <LatestFollowUp info={text}/>
            //     }
            // },
            /* {
               title: 'Course/University',
               key: 'counsellingDesk.course',
               width: 450,
               dataIndex: 'course',
               render: (text, record) => {
                 return (
                   <div>
                     <div>
                       {record.counsellingDesk && record.counsellingDesk.course.map((item) => {
                         return <ul className={styles.ul}>
                           <li><b>{item.courseName}</b></li>
                           <li>{item.universityInstitutionName}</li>
                           <li>
                             <small>   {item.univData && item.univData.universityCityId && `${item.univData.universityCityId.cityName} ,`}
                               {item.univData && item.univData.universityStateId && `${item.univData.universityStateId.stateName} ,`}
                               {item.univData && item.univData.universityCountryId && `${item.univData.universityCountryId.countryName}`}</small>
                           </li>

                         </ul>

                       })}
                     </div>
                   </div>
                 )
               }
             }, */
            // {
            //     title: 'Course/University',
            //     key: 'counsellingDesk.course',
            //     width: 380,
            //     dataIndex: 'course',
            //     render: (text, record) => {
            //         return (<CollapseViewBox>
            //             {record.counsellingDesk}
            //         </CollapseViewBox>)
            //     }
            // },


            // {
            //     title: 'Test Score',
            //     key: 'ieltsOverallScore',
            //     width: 180,
            //     dataIndex: 'ieltsOverallScore',
            //     render: (text, record) => {
            //         return (
            //             <div style={{fontSize: '12px'}}>
            //                 <div
            //                     style={{paddingBottom: '4px'}}> {record.testType && text ? `${record.testType} OverAll : ${text}` : null}</div>
            //                 <div
            //                     style={{paddingBottom: '4px'}}>{record && record.profile && record.profile.reading ? `Reading : ${record.profile.reading}` : null} {record && record.profile && record.profile.writing ? `Writing : ${record.profile.writing}` : null} </div>
            //                 <div>{record && record.profile && record.profile.listening ? `Listening : ${record.profile.listening}` : null} {record && record.profile && record.profile.speaking ? `Speaking : ${record.profile.speaking}` : null}</div>

            //             </div>
            //         )
            //     }
            // },
            // {
            //     title: 'Preference',
            //     width: 180,
            //     key: 'preference',
            //     render: (val, row) => {
            //         return row.totalPreference ? (
            //             <ul className={common.ul}>
            //                 {row.totalPreference.map((val, inde) => {
            //                     return <li key={inde}>{val.country}</li>
            //                 })}
            //             </ul>
            //         ) : null
            //     }
            // },
            {
                title: 'Transfered Date',
                key: 'moveDeskDate.moveToRegistrationDesk',
                dataIndex: 'moveDeskDate.moveToRegistrationDesk',
                width: 100,
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('lll') : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Created By',
                width: 150,
                key: 'createdByUser',
                dataIndex: 'createdByUser',
                searchTextName: 'createdByUser',
                filterRegex: true,
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
        ]

        return (
            <PageHeaderWrapper
                deskColor={deskColor}
                title={` REGISTRATION DESK : ${this.state.count} `}
                subTitle={`Follow Up Overdue : ${this.state.followDuesCount}`}
                followUpsCallback={this.followUpsCallback}
            >
                {this.state.showFollowUp ? (
                    <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
                ) : null}

                {/*   <Card style={{ marginBottom: 10 }}>
          <div style={{ display: 'flex' }}>
            <h5 className="search_title" style={{ paddingTop: 8 }}>
              SEARCH BY COUNSELLOR
            </h5>
            <Select
              showSearch
              allowClear
              style={{
                width: 214,
                paddingRight: 16,
                paddingLeft: 9
              }}
              value={this.state.counsellorId}
              placeholder="Select Counsellor"
              onChange={counsellorId => {
                this.setState(
                  { counsellorId: counsellorId && counsellorId.toString() },
                  () => {
                    this.table.current.reload()
                  }
                )
              }}
              filterOption={(input, option) => {
                return (
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                )
              }}>
              {allCounsellor.map((val, idn) => {
                return (
                  <Option key={idn} value={val._id}>
                    {val.name}
                  </Option>
                )
              })}
            </Select>
            <h5 className="search_title" style={{ paddingTop: 8 }}>
              SEARCH BY BRANCH
            </h5>
            <Select
              showSearch
              allowClear
              style={{
                width: 214,
                paddingRight: 16,
                paddingLeft: 9
              }}
              value={this.state.branchId}
              placeholder="Select Branch"
              onChange={branchId => {
                this.setState(
                  { branchId: branchId && branchId.toString() },
                  () => {
                    this.table.current.reload()
                  }
                )
              }}
              filterOption={(input, option) => {
                return (
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                )
              }}>
              {allBranches.map((val, idn) => {
                return (
                  <Option key={idn} value={val._id}>
                    {val.branchName}
                  </Option>
                )
              })}
            </Select>
          </div>
        </Card>*/}
                {this.state.showWhatsAppSms ? (
                    <WhatsAPPSMS counsellingData={counsellingData} onClose={this.closeWhatsSMS} />
                ) : null}

                {this.state.showSMS ? (
                    <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
                ) : null}

                {this.state.showEmail ? (
                    <EmailDrawer counsellingData={counsellingData} onClose={this.closeEmail} />
                ) : null}
                <Card style={{ marginBottom: 10 }}>
                    <div>
                        <Col span={6} >
                            <label>Date of Lead transfer</label><br></br>
                            <RangePicker
                                showTime={{ format: 'HH:mm' }}
                                format="YYYY-MM-DD"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                        <Col span={4} style={{ marginTop: 15 }}>
                            {
                                rightAuth.checkRights("RegistrationDeskExcelExport.view") ?
                                    <Button
                                        style={{}}
                                        onClick={() => this.exportExcel()}>
                                        Export Excel
                                    </Button>
                                    : null
                            }

                        </Col>
                    </div>
                </Card>
                <Card style={{ marginBottom: 10 }}>
                    <div className={styles.filterBlock}>
                        <div className={styles.myBtnGroup}>
                            {
                                counsellors && counsellors.length ?
                                    <div style={{ float: 'left' }}>
                                        {/* <Select
                                            allowClear
                                            style={{
                                                width: '40%',
                                                marginRight: '1rem'
                                            }}
                                            showSearch={true}
                                            className={common.width100Pr}
                                            value={this.state.counsellorId}
                                            placeholder="Select Option"
                                            optionFilterProp="display"
                                            onChange={counsellorId => {
                                                this.setState(
                                                    {
                                                        counsellorId: counsellorId && counsellorId.toString()
                                                    },
                                                    () => {
                                                        setTimeout(() => {
                                                            this.table.current.reload()
                                                        }, 500);
                                                    }
                                                );
                                            }}>
                                            {counsellors.map((val, idn) => {
                                                return (
                                                    <Option key={idn} value={val.id}>
                                                        {val.display}
                                                    </Option>
                                                )
                                            })}
                                        </Select> */}
                                        {/* <Input
                                            allowClear
                                            style={{
                                                width: '40%',

                                            }}
                                            hidden={rightAuth.checkRights("searchStudent.view") == true ? false : true}

                                            value={this.state.studentSearchId}
                                            placeholder="Enter Student ID"
                                            onChange={studentSearchId => {
                                                this.setState(
                                                    {
                                                        studentSearchId: studentSearchId && studentSearchId.target.value
                                                    },
                                                    () => {
                                                        setTimeout(() => {
                                                            this.table.current.reload()
                                                        }, 500);
                                                    }
                                                );
                                            }} /> */}
                                    </div>
                                    : null}
                            <div className="antd-pro-containers-student-inquiry-all-styles-myBtnGroup">
                                <Button
                                    className={styles.btn}
                                    type="primary"
                                    onClick={() => this.showEmail()}>Send E-mail
                                </Button>
                                <Button
                                    type="primary"
                                    className={styles.btn}
                                    onClick={() => this.showSMS()}>Send SMS
                                </Button>
                                <Button
                                    type="primary"
                                    className={styles.btn}
                                    onClick={() => this.showWhatsAppSms()}>Whatsapp
                                </Button>
                                <Button
                                    className={styles.btn}
                                    onClick={() => this.selectAllUserFxn()}>Select Visible
                                </Button>
                                <Button
                                    className={styles.btn}
                                    onClick={() => this.unselectAllUserFxn()}>Unselect Visible
                                </Button>
                            </div>
                        </div>
                    </div>
                </Card>
                {
                    showDroppedLeads || showDropLead ?
                        <Card bordered={true} style={{ marginBottom: 10 }}>
                            <Row>
                                <Col span={4}>
                                    <RightsWrapper myRight={"dropLead.view"}>
                                        <Popconfirm
                                            title="Are you sure to drop this inquiry?"
                                            onConfirm={() => {
                                                this.dropLeads()
                                            }}
                                            onCancel={() => {
                                            }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button
                                                className={styles.btn}
                                                type="primary">Drop Selected Leads
                                            </Button>
                                        </Popconfirm>
                                    </RightsWrapper>
                                </Col>
                                <Col span={4}>
                                    <RightsWrapper myRight={"showDropLead.view"}>
                                        <Button
                                            className={styles.btn}
                                            type="primary"
                                            onClick={() => {
                                                this.toggleDroppedLeads()
                                            }}
                                        >{this.state.showDropped ? "Show All Leads" : 'Show Dropped Leads'}
                                        </Button>
                                    </RightsWrapper>
                                </Col>
                            </Row>

                        </Card>
                        : null
                }
                <Card bordered={true}>
                    <Search id="search-student-input" placeholder="Search Student" onSearch={value => this.changeSearchValue(value)} enterButton />
                    <TableComp
                        id={'registrationDesk'}
                        showSelector={true}
                        columns={columns}
                        ref={this.table}
                        apiRequest={params => this.apiRequest(params, columns)}
                        extraProps={{ scroll: { x: 2100 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }} />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search

})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegistrationDesk)
